var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWork2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 23 Copy@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "30 0 55.9807621 15 55.9807621 45 30 60 4.01923789 45 4.01923789 15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.5%",
    y: "-32.5%",
    width: "185.0%",
    height: "185.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.622987115   0 0 0 0 0.642494553   0 0 0 0 0.759539176  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-896.000000, -1462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(319.000000, 1263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table-1-copy",
    transform: "translate(430.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy",
    transform: "translate(156.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon-Copy-16"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-pie-chart-1100239-copy",
    transform: "translate(18.000000, 18.000000)",
    stroke: "#2283FB",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00277084936,10 C-0.0615139199,7.36590875 0.995799033,4.7226078 2.85918951,2.85917922 C4.72237925,0.995986785 7.3656764,-0.0613572096 10,0.00275644639",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99983701,0 C10,3.33313649 10,6.66650919 9.99983701,10 L0,10",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinejoin: "round",
    points: "0 12 10.4726328 12 18.5568929 21.9541062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00082659259,12 C-0.0256537301,14.255381 0.584756731,16.5151246 1.73727972,18.4279063 C2.88961718,20.340688 4.57999659,21.9000921 6.5458906,22.8639893 C8.36113286,23.753939 10.4049502,24.1352122 12.4053531,23.9573685 C14.405756,23.7795249 16.9141951,23.1514585 18.5568929,21.9541062",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinejoin: "round",
    points: "12 0 12 11.333315 20 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0.00631630582 C14.2942447,-0.0709190521 16.6067587,0.562090935 18.552123,1.79955878 C20.4974873,3.03702663 22.0677642,4.87412753 23.0010099,7.00421087 C24.0341571,9.36235288 24.2764582,12.0696217 23.6788509,14.5782671 C23.081231,17.0871685 21.9800129,19.3822168 20,21",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWork2);
export default __webpack_public_path__ + "static/media/how-it-work2.6e21bc248903ca6a1e918789902f115b.svg";
export { ForwardRef as ReactComponent };